<template>
  <ed-modal
    :show="showModal"
    @close="$emit('close')"
    @validate="onSave"
    :validation="true"
    type='medium'
    :title="title"
    primaryButton="SAVE"
    secondary-button="CANCEL"
    :closeOnEsc="true"
    >
        <div
            class="content form-group"
            slot="body">
            <ed-form class="col-md-12 no-pad" :submit-visible="false">
              <section class="col-md-5 no-pad">
                <p>Address Information</p>
              </section>
              <section class="col-md-7 pull-right">
                <div class="row">
                    <ed-input
                    field-label="Entity Legal Name"
                    v-model="model.newAddress.EntityLegalName"
                    placeholder="Enter the Entity Legal Name"
                    name='legal_entity_name'
                    />
                </div>
                <div class="row">
                    <ed-input
                    field-label="Funding Entity Name"
                    v-model="model.newAddress.FundingEntityName"
                    placeholder="Enter the Funding Entity Name"
                    required
                    :error="doDisplayFundingEntityNameError"
                    :helptip-header=" doDisplayFundingEntityNameError && 'Error' || ''"
                    :helptip-body="doDisplayFundingEntityNameError && 'Please fill in Funding Entity Name' || ''"
                    @change="doDisplayFundingEntityNameError = false"
                    name='funding_entity_name'
                    />
                </div>
                <div class="row">
                    <ed-input
                    field-label="Address"
                    v-model="model.newAddress.Address"
                    placeholder="Enter Address"
                    name='address'
                    />  
                </div>
                <div class="row">
                    <ed-input
                    field-label="Address Line 2"
                    v-model="model.newAddress.Address2"
                    placeholder="Enter Address Line2"
                    
                    name='address2'
                    />
                </div>
                <div class="row">
                    <ed-select
                      field-label="Country"
                        placeholder="Select a country..."
                        :options="countries"
                        v-model="model.newAddress.Country"
                        label="CountryName"
                        track-by="CountryID"
                        :openEndpoint='api.$.profile.getAllCountries'
                        @select="countrySelected($event)"
                        @open="fetchCountriesOnOpen"
                        @keyup="fetchCountries"
                        @close="restoreCountries"
                        
                        name="country"
                    ></ed-select>
                </div>
                <div class="row">
                    <div class="col-md-4 no-pad">
                        <ed-select
                        v-if="isUS()"
                        field-label="State"
                        placeholder="Select a state"
                        :options="USStates"
                        v-model="model.newAddress.State"
                        @open="fetchUSStatesOnOpen"
                        @keyup="fetchUSStates"
                        @close="restoreUSStates"
                        label="StateName"
                        track-by="StateID"
                        :disabled="disableControls"
                        
                        name='us_states'
                        />
                        <ed-select
                        v-if="isCanada()"
                        field-label="State/Region"
                        placeholder="Select a region"
                        :options="canadaStates"
                        v-model="model.newAddress.CanadaState"
                        @open="fetchCanadaStatesOnOpen"
                        @keyup="fetchCanadaStates"
                        @close="restoreCanadaStates"
                        label="StateName"
                        track-by="StateName"
                        :disabled="disableControls"                        
                        name='canada_states'
                        />
                        <ed-input
                        v-if="!model.newAddress.Country || !isCanada() && !isUS()"
                        field-label="State/Region"
                        placeholder="Select a region"
                        v-model="model.newAddress.Region"
                        :disabled="disableControls"                        
                        name='state_region'/>
                    </div>
                    <ed-input
                    field-label="City"
                    v-model="model.newAddress.City"
                    
                    placeholder="Enter City"
                    class="col-md-3"
                    name="city"
                    />
                    <ed-input
                    field-label="Postal/Zip Code"
                    v-model="model.newAddress.ZipCode"
                    placeholder="Enter Postal Code"
                    class="col-md-5 no-pad"
                    
                    name="zip_code"
                    />     
                </div>
                <div class="row">           
                    <ed-input
                    field-label="VAT ID"
                    v-model="model.newAddress.VatId"
                    placeholder="Enter VAT ID"
                    name="vat_id"
                    />
                </div>
                <div class="row">           
                    <ed-input
                    field-label="EIN"
                    v-model="model.newAddress.EIN"
                    placeholder="Enter EIN"
                    name="EIN"
                    required
                    />
                </div>
                <div class="row">
                  <ed-input
                      field-label="Recipient Email Address"
                      v-model="model.newAddress.Email"
                      placeholder="Enter Recipient Email Address"
                      required
                      :error="doDisplayEmailError"
                      :helptip-header=" doDisplayEmailError && 'Error' || ''"
                      :helptip-body="doDisplayEmailError && 'Please fill in Email Address' || ''"
                      @change="doDisplayEmailError = false"
                      name="email_address"
                      helpText="Use a semicolon to separate multiple email addresses"
                  >
                  </ed-input>
                </div>
                <div class="row">
                  <ed-select-list
                    v-if='!hasAPSettingsByBU'
                    field-label='Divisions'
                    v-model='divisions'
                    :endpoint='api.$.FundingInvoiceAndApSetting.getDivisionsForFundingAddresss'
                    track-by='DivisionId'
                    label='DivisionName'
                    :params='payload'
                    required
                    :error="doDisplayDivisionsError"
                    :helptip-header="doDisplayDivisionsError && 'Error' || ''"
                    :helptip-body="doDisplayDivisionsError && 'Please select a Division' || ''"
                    @select='selectDivision'
                  />
                </div>
                <div class="row">
                  <ed-select-list
                    v-if='hasAPSettingsByBU'
                    field-label='Business Units'
                    v-model='businessUnits'
                    :endpoint='api.$.FundingInvoiceAndApSetting.getBusinessUnitsForFundingAddresss'
                    track-by='Id'
                    label='Name'
                    :params='payload'
                    required
                    :error="doDisplayBUError"
                    :helptip-header="doDisplayBUError && 'Error' || ''"
                    :helptip-body="doDisplayBUError && 'Please select a Business Unit' || ''"
                    @select='selectBusinessUnit'
                  />
                </div>
              </section>
              <div class="clear"></div>
            </ed-form>
        </div>
    </ed-modal>
</template>

<script>
export default {
  props: {
    model: Object,
    showModal: Boolean
  },
  data() {
    return {
      statesRegions: [],
      fundingAddress: this.model.newAddress,
      countries: [],
      originalCountries: [],

      USStates: [],
      USOriginalStates: [],

      canadaStates: [],
      originalCanadaStates: [],
      counter: 0,
      doDisplayDivisionsError: false,
      doDisplayBUError: false,
      doDisplayFundingEntityNameError: false,
      doDisplayEmailError: false,
      hasAPSettingsByBU: this.model.HasAPSettingsByBU,
      payload: {VendorAddressId: this.model.newAddress.VendorAddressId || 0},
      divisions: this.model.edit
                ? this.model.newAddress.Divisions
                : [],
      businessUnits: this.model.edit
                ? this.model.newAddress.BusinessUnits
                : []
    }
  },
  computed: {
    title() {
      return this.model.edit ? 'Edit Funding Address' : 'Add Funding Address'
    }
  },
  methods: {
    selectDivision() {
      this.doDisplayDivisionsError = false
    },
    selectBusinessUnit() {
      this.doDisplayBUError = false
    },
    fetchCountriesOnOpen() {
      if (this.countries.length) {
      } else {
        this.api.forms.post(
          this.api.$.profile.getAllCountries,
          {
            q: ''
          }
          ).then(r => {
            if (r && r.data && r.data.Data) {
              this.countries = r.data.Data
              this.originalCountries = r.data.Data
            }
          }
        ).catch(e => console.warn(e))
      }
    },

    fetchCountries(value) {
      this.counter || this.api.forms.post(
        this.api.$.profile.getAllCountries,
        {
          q: value || ''
        }
      ).then(r => {
        this.counter = 0
        if (r && r.data && r.data.Data) {
          this.countries = r.data.Data
        }
      }
      ).catch(e => {
        console.warn(e)
        this.counter = 0
      })
      this.counter = 1
    },

    restoreCountries() {
      if (this.counter === 0) {
        this.countries = utils.copy(this.originalCountries)
      }
    },

    countrySelected(e) {
      this.doDisplayCountryError = false
      this.resetState(e.CountryName)
    },

    resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.model.newAddress.state = {
          StateID: 0,
          StateName: ''
        }
        this.model.newAddress.CanadaState = {
          StateID: 0,
          StateName: ''
        }
        this.model.newAddress.region = ''
      } else {
        this.originalCountryName = countryName
      }
    },
    // Fetch States on search text
    fetchUSStates(value) {
      var url = this.getStatesUSURL()
      this.fetchStates(value, url)
    },

    getStatesUSURL() {
      return this.api.$.profile.getAllStates
    },
    getStatesCanadaURL() {
      return this.api.$.profile.getCanadaStates
    },
    fetchCanadaStates(value) {
      var url = this.getStatesCanadaURL()
      this.fetchStates(value, url)
    },
    fetchStates(value, url) {
      this.counter || this.api.forms.post(
        url,
        {
          q: value || ''
        }
      ).then(r => {
        this.counter = 0
        if (r && r.data && r.data.Data) {
          this.mapStatesDataOnFetch(r.data.Data)
        }
      }
      ).catch(e => {
        console.warn(e)
        this.counter = 0
      })
      this.counter = 1
    },
    mapStatesDataOnFetch(data) {
      if (this.isUS()) {
        this.USStates = data
      } else {
        this.canadaStates = data
      }
    },

    // Fetch States on OPEN
    fetchUSStatesOnOpen() {
      var url = this.getStatesUSURL()
      this.fetchStatesOnOpen(this.USStates, url)
    },
    fetchCanadaStatesOnOpen() {
      var url = this.getStatesCanadaURL()
      this.fetchStatesOnOpen(this.canadaStates, url)
    },
    fetchStatesOnOpen(states, url) {
      if (states.length && (this.isCanada() || this.isUS())) {
      } else {
        this.api.forms.post(
          url,
          {
            q: ''
          }
          ).then(r => {
            if (r && r.data && r.data.Data) {
              this.mapStatesDataOnOpen(r.data.Data)
            }
          }
        ).catch(e => console.warn(e))
      }
    },
    mapStatesDataOnOpen(data) {
      if (this.isUS()) {
        this.USStates = this.USOriginalStates = data
      } else {
        this.canadaStates = this.originalCanadaStates = data
      }
    },

    // Restore States
    restoreUSStates() {
      this.restoreStates(this.USStates, this.USOriginalStates)
    },
    restoreCanadaStates() {
      this.restoreStates(this.canadaStates, this.originalCanadaStates)
    },
    restoreStates(states, originalStates) {
      if (this.counter === 0) {
        this.states = utils.copy(originalStates)
      }
    },
    isCanada() {
      return this.model.newAddress.Country && this.model.newAddress.Country.CountryName === 'Canada'
    },
    isUS() {
      return this.model.newAddress.Country && this.model.newAddress.Country.CountryName === 'United States'
    },
    onSave() {
      if (!this.isValid()) return
      let VendorAddressDTO = {
        VendorAddressId: this.model.newAddress.VendorAddressId,
        Name: this.model.newAddress.FundingEntityName,
        EntityLegalName: this.model.newAddress.EntityLegalName,
        Address: this.model.newAddress.Address,
        Address2: this.model.newAddress.Address2,
        CountryId: this.model.newAddress.Country.CountryID,
        Country: this.model.newAddress.Country.CountryName,
        StateId: this.isUS()
                  ? this.model.newAddress.State.StateID
                : null,
        StateName: this.isUS()
                  ? this.model.newAddress.State.StateName
                  : '',
        Region: this.isCanada() ? this.model.newAddress.CanadaState.StateName : this.model.newAddress.Region,
        City: this.model.newAddress.City,
        Zip: this.model.newAddress.ZipCode,
        VatNo: this.model.newAddress.VatId,
        EIN: this.model.newAddress.EIN,
        Email: this.model.newAddress.Email || ''
      }
      let param = {
        VendorAddressDTO,
        DivisionsIds: this.divisions,
        BusinessUnitIds: this.businessUnits
      }
      if (!this.model.edit) {
        this.api.post(this.api.$.FundingInvoiceAndApSetting.saveFundingAddress, param).then(r => {
          this.$emit('save')
        })
      } else {
        this.api.post(this.api.$.FundingInvoiceAndApSetting.updateFundingAddress, param).then(r => {
          this.$emit('save')
        })
      }
    },
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    validateMultiemails(emails) {
      var multiEmails = emails.split(';')
      for (let i = 0; i < multiEmails.length; i++) {
        if (!this.validateEmail(multiEmails[i])) {
          return false
        }
      }
      return true
    },
    isValid() {
      var result = true
      if (
        !(this.model.newAddress.FundingEntityName.length &&
          this.model.newAddress.FundingEntityName.length > 0
        )
      ) {
        this.doDisplayFundingEntityNameError = true
        result = false
      }

      if (
        !(
        this.model.newAddress.Email.length &&
        this.model.newAddress.Email.length > 0
        ) || !this.validateMultiemails(this.model.newAddress.Email)
      ) {
        this.doDisplayEmailError = true
        result = false
      }

      if (!this.hasAPSettingsByBU && this.divisions && this.divisions.length <= 0) {
        this.doDisplayDivisionsError = true
        result = false
      }
      if (this.hasAPSettingsByBU && this.businessUnits && this.businessUnits.length <= 0) {
        this.doDisplayBUError = true
        result = false
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/FundingInvoiceAndAPSettings/FundingAddresses/AddEditFundingAddress.vue